import { getFacilitiesForFloor } from "@lib/logic";
import { getFloorsByBuildingId, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

import { HaNContext } from "../shell/HaNContext";

/**
 * The facilities the tab lists on the selected floor, after the type filter, and when the floor has none, the ones on
 * the floors next to it. It's loading until the building's resources are in.
 */
export const useFacilitiesModel = () => {
  const { isTabLoading, building, floor, filterData } = useRequiredContext(HaNContext);
  const floors = useAppSelector(state => getFloorsByBuildingId(state, building.buildingId ?? ""));

  const { facilities, suggestions } = getFacilitiesForFloor({
    facilities: filterData.facilities.filteredData,
    floorId: floor.floorId,
    floors,
  });

  return { isLoading: isTabLoading, facilities, suggestions };
};
